import React, { useState, useMemo, useEffect } from 'react';
import {
    TextField,
    Autocomplete,
    Typography,
    Grid,
    Container,
    FormControl,
    Button
} from '@mui/material';
import {
    DateRangePicker,
    LocalizationProvider
} from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { StudyReport } from '../../../../../api'

const getPreviousMonthRange = () => {
    const today = dayjs();
    const start = today.subtract(1, 'month').startOf('month');
    const end = today.subtract(1, 'month').endOf('month');
    return [start, end];
}

const StudyReports = ({ user }) => {

    const [selectedOrgs, setSelectedOrgs] = useState(user.access.filter(e => e.admin));
    const [dateRange, setDateRange] = useState(getPreviousMonthRange());
    const [submitError, setSubmitError] = useState()

    const handleSubmit = e => {

        e.preventDefault()
        try {
            StudyReport({ orgs: selectedOrgs.map(e => e.org.id), from: dateRange[0].format('YYYY-MM-DD'), to: dateRange[1].add(1, 'day').format('YYYY-MM-DD') }).then(async blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${dateRange[0].format('YYYYMMDD')}-${dateRange[1].format('YYYYMMDD')} DICOMStudies.csv`;  // set your filename
                a.click();
                window.URL.revokeObjectURL(url);
            }).catch(async error => {
                if (error.response && error.response.data instanceof Blob) {
                    try {
                        const text = await error.response.data.text();
                        const json = JSON.parse(text);
                        setSubmitError(json.errors);
                    } catch (parseError) {
                        setSubmitError('Invalid request')
                    }
                } else {
                    setSubmitError('Invalid request')
                }
            })
        } catch (e) { setSubmitError('Invalid request') }

    }
    useEffect(() => setSubmitError(), [dateRange, selectedOrgs])

    const orgs = useMemo(() => user.access.filter(e => e.admin), [user])

    return (
        <Container>
            <form onSubmit={handleSubmit} noValidate>
                <Grid
                    container
                    sx={{ mb: 3 }}
                    spacing={3}
                    justifyContent="left"
                    maxWidth="sm"
                >

                    <Grid size={12}>
                        <Typography component="h1" variant="h4">DICOM Study Report</Typography>
                    </Grid>
                    {submitError ? <FormControl sx={{ mb: 1 }} fullWidth variant="standard"><Typography component="p" color="error">{submitError}</Typography></FormControl> : null}
                    <Typography component="h2" variant="h6">Select Organizations</Typography>
                    <FormControl fullWidth variant="standard">
                        <Autocomplete
                            multiple
                            options={orgs}
                            getOptionLabel={option => option.org.name}
                            value={selectedOrgs}
                            onChange={(event, newValue) => setSelectedOrgs(newValue)}
                            renderInput={(params) => <TextField required {...params} label="Organizations" />}
                        />
                    </FormControl>
                    <Typography component="h2" variant="h6">Select Date Range</Typography>
                    <FormControl fullWidth variant="standard">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateRangePicker
                                value={dateRange}
                                onChange={(newValue) => setDateRange(newValue)}
                                required
                                slotProps={{
                                    textField: {
                                        required: true,
                                    },
                                }}
                                textField={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Grid>
                <Grid container spacing={3} justifyContent="right" maxWidth="sm">
                    <Button variant="contained" color="primary" type="submit" startIcon={<FileDownloadIcon />}>
                        Export
                    </Button>
                </Grid>
            </form>
        </Container>
    )

}

export default StudyReports